import { render, staticRenderFns } from "./articlesClassification.vue?vue&type=template&id=f78862c0&scoped=true&"
import script from "./articlesClassification.vue?vue&type=script&lang=js&"
export * from "./articlesClassification.vue?vue&type=script&lang=js&"
import style0 from "./articlesClassification.vue?vue&type=style&index=0&id=f78862c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78862c0",
  null
  
)

export default component.exports